import { BuildingType, FloorType, AreaType } from "api/schema";
import { startOfToday } from "date-fns";

export interface State {
  selectedDate: Date;
  selectedBuilding?: BuildingType;
  floors: FloorType[];
  selectedFloor?: FloorType;
  freeSpaces: AreaType[];
  selectedFreeSpace?: AreaType;
  hoursStart?: number;
  hoursEnd?: number;
  unavailableSlots: number[];
}

export const initialState: State = {
  selectedDate: startOfToday(),
  floors: [],
  freeSpaces: [],
  unavailableSlots: [],
};

export enum ActionType {
  RESET,
  SELECT_BUILDING,
  SELECT_DATE,
  SET_FLOORS,
  SELECT_FLOOR,
  SET_FREE_SPACES,
  SELECT_FREE_SPACE,
  SET_HOURS_RANGE,
  SET_UNAVAILABLE_SLOTS,
}

export interface Action {
  type: ActionType;
  payload?: unknown;
}
